/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Okular_BestInputs */

const en_pc_alt_t_okular_best = /** @type {(inputs: Pc_Alt_T_Okular_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading and annotating PDFs and many other document formats`)
};

const zh_pc_alt_t_okular_best = /** @type {(inputs: Pc_Alt_T_Okular_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读和批注 PDF 及多种其他文档格式`)
};

/**
* | output |
* | --- |
* | "Reading and annotating PDFs and many other document formats" |
*
* @param {Pc_Alt_T_Okular_BestInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_okular_best = /** @type {((inputs?: Pc_Alt_T_Okular_BestInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Okular_BestInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_okular_best(inputs)
	return zh_pc_alt_t_okular_best(inputs)
});
export { pc_alt_t_okular_best as "pc.alt.t.okular.best" }